export const API_CONFIG = {
  // Development
  base_api_url: 'http://localhost/VetoNest/public/index.php/api/',
  base_url: 'http://localhost/VetoNest/public/',
  
  // Production - uncomment when deploying
  // base_api_url: 'https://backend.vetonest.com/api/',
  // base_url: 'https://backend.vetonest.com/',
};